<template>
  <el-form-item :label="label" :prop="prop">
    <el-date-picker
      v-model="queryDate"
      :type="dateType"
      range-separator="至"
      :start-placeholder="startText"
      :end-placeholder="endText"
      clearable
      @change="dateChange"
      :value-format="valueFormat"
      :default-time="defaultTime"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
  </el-form-item>
</template>
<script>
import moment from 'moment'
export default {
  name: "date-range",
  props: {
    label: {
      type: String,
      default: "单据时间",
    },
    startText: {
      type: String,
      default: "开始时间",
    },
    endText: {
      type: String,
      default: "结束时间",
    },
    dateType: {
      type: String,
      default: "daterange",
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss",
    },
    defaultTime: {
      type: Array,
      default() {
        return ["00:00:00", "23:59:59"];
      },
    },
    startKey: {
      type: String,
      default: "dateStart",
    },
    endKey: {
      type: String,
      default: "dateEnd",
    },
    prop: {
      type: String,
      default: ''
    },
    pickerOptions: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      queryDate: []
    };
  },
  methods: {
    dateChange(val) {
      // 为什么用两层$parent 因为在el-form中 一层只能找到el-form
      if (val && val.length) {
        this.$parent.$parent.params[this.startKey] = val[0];
        this.$parent.$parent.params[this.endKey] = val[1];
      } else {
        this.$parent.$parent.params[this.startKey] = "";
        this.$parent.$parent.params[this.endKey] = "";
      }
    }
  },
};
</script>
<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/components/date-range/index.vue